import React,{useState} from "react";
import { useDropzone } from "react-dropzone";
import { useSelector } from "react-redux";
const ImportData = () => {
  const translation = useSelector(state => state.root.translation);
  const [uploadResult, setUploadResult] = useState(null);
  const [loading, setLoading] = useState(false);

  // const dynamicPath = "../../../../../public/assets/img/icons/download.svg"; // Replace with your dynamic path or variable

  const onDrop = async (acceptedFiles) => {
    
    if (!acceptedFiles[0]) {
      alert("Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", acceptedFiles[0]);
    setLoading(true);
    try {
      const token = "bearer "+localStorage.getItem('accessToken')
      const response = await fetch('https://fida.forgedrift.com/api/uploadDataFile', {
        method: 'PUT',
        headers: {
          'Authorization': token,
        },
        body: formData,
      });

      const result = await response.json();
      setUploadResult(result);
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("Error uploading file.");
    } finally {
      setLoading(false);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ".csv",
  });

  const renderInvalidRecords = (invalidRecords) => {
    return invalidRecords.map((record, index) => (
      <tr key={index}>
        <td>{record.store}</td>
        <td>{record.date}</td>
        <td>{record.hour}</td>
        {/* <td>{record.sls}</td>
        <td>{record.trn}</td>
        <td>{record.is}</td>
        <td>{record.sh}</td>
        <td>{record.st}</td>
        <td>{record.pb}</td>
        <td>{record.dw}</td> */}
      </tr>
    ));
  };
  
    return (
      <div>
        <div className="page-wrapper cardhead data-import-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">{translation?.data_import}</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">{translation?.import_kpi_data}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title">{translation?.kpi_data_file_upload}</h5>
                  </div>
                  <div className="card-body">
                    <div
                      className="custom-file-container"
                      data-upload-id="myFirstImage"
                    >
                      <div
                        {...getRootProps()}
                        style={{
                          border: "2px dashed #90979F",
                          padding: "20px",
                          textAlign: "center",
                          cursor: "pointer",
                          height: "200px"
                        }}
                      >
                        {loading && (
                      <div
                        className="loader-content"
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: "rgba(255, 255, 255, 0.7)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          zIndex: 2,
                        }}
                      >
                        <div id="global-loader">
                          <div className="whirly-loader"></div>
                        </div>
                      </div>
                    )}
                        <input {...getInputProps()} />
                        {isDragActive ? (
                          <p style={{ color: "#13B3C1", paddingTop: "60px" }}>
                            {translation["drop_the_file_here..."]}
                          </p>
                        ) : (
                         <div className="import-file-wrap">
                            <div>
                              <img src="csv-img.jpeg"/>
                            </div>
                           <div className="import-file-inner">
                            <button>{translation?.browse || "Browse"}</button>
                            <p>
                            {/* {translation['drag_drop_a_csv_file_here_or_click_to_select_one']} */}
                            {translation?.drag_drop_a_csv_file || "or drag and drop a CSV file"}
                            
                          </p>
                          </div>
                         </div>
                        )}
                      </div>
                    </div>
                    {uploadResult && (
                      <div className="mt-4">
                        {uploadResult.response?.invalid?.length === 0 && uploadResult.response?.validCount > 0 ? (
                          <div className="alert alert-success">
                            {translation["all_records_were_successfully_uploaded."]} 
                            {/* Success Count:{" "}
                            {uploadResult.response.validCount} */}
                          </div>
                        ) : (
                          <div>
                            <div className="alert alert-warning">
                              {uploadResult.response?.invalid?.length} records were invalid.
                              Success Count: {uploadResult.response?.validCount}
                            </div>
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th>Store</th>
                                  <th>Date</th>
                                  <th>Hour</th>
                                  {/* <th>SLS</th>
                                  <th>TRN</th>
                                  <th>IS</th>
                                  <th>SH</th>
                                  <th>ST</th>
                                  <th>PB</th>
                                  <th>DW</th> */}
                                </tr>
                              </thead>
                              <tbody>
                                {renderInvalidRecords(uploadResult.response.invalid)}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
export default ImportData;

// import React from "react";
// import { useDropzone } from "react-dropzone";

// const ImportData = () => {
//  // const [file, setFile] = useState(null);
//   const dynamicPath = "../../../../../public/assets/img/icons/download.svg"; // Replace with your dynamic path or variable

//   const onDrop = async (acceptedFiles) => {
//    // setFile(acceptedFiles[0]);
//     console.log('acceptedFiles[0]',acceptedFiles[0]);
//     if (!acceptedFiles[0]) {
//       alert("Please select a file first.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("file", acceptedFiles[0]);

//     try {
//       const response = await fetch('https://fida.forgedrift.com/api/uploadDataFile', {
//         method: 'PUT',
//         headers: {
//           'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiJwaTN0ZHZzUTdLcnRlTFpMNiIsImFjY2Vzc1Rva2VuRXhwIjp7ImRhdGUiOiIyMDI0LTA5LTIxIiwidGltZSI6IjIwOjQ2OjQ3IiwidGltZVN0YW1wIjoxNzI2OTUxNjA3MTg3LCJnbXQiOiIrMDAwMCJ9LCJyZWZyZXNoVG9rZW5FeHAiOnsiZGF0ZSI6IjIwMjQtMDktMjEiLCJ0aW1lIjoiMjA6NDY6NDciLCJ0aW1lU3RhbXAiOjE3MjY5NTE2MDcxODcsImdtdCI6IiswMDAwIn0sImlhdCI6MTcyNDM1OTYwNywiZXhwIjoxNzI0MzU5NjY3fQ.hcyd7Q3iu-g8oOEJVVNu47S1G6pRTWWvu4H6HVFlBTc',
//         },
//         body: formData,
//       });

//       if (response.ok) {
//         alert("File uploaded successfully!");
//       } else {
//         alert("File upload failed.");
//       }
//     } catch (error) {
//       console.error("Error uploading file:", error);
//       alert("Error uploading file.");
//     }
//   };

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     accept: ".csv",
//   });

//   return (
//     <div>
//       <div className="page-wrapper cardhead">
//         <div className="content container-fluid">
//           <div className="page-header">
//             <div className="row">
//               <div className="col-sm-12">
//                 <h3 className="page-title">Data import</h3>
//                 <ul className="breadcrumb">
//                   <li className="breadcrumb-item">Import Kpi data</li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-md-12">
//               <div className="card">
//                 <div className="card-header">
//                   <h5 className="card-title">Kpi data file upload</h5>
//                 </div>
//                 <div className="card-body">
//                   <div
//                     className="custom-file-container"
//                     data-upload-id="myFirstImage"
//                   >
//                     <div
//                       {...getRootProps()}
//                       style={{
//                         border: "2px dashed #13B3C1",
//                         padding: "20px",
//                         textAlign: "center",
//                         cursor: "pointer",
//                         height: "200px"
//                       }}
//                     >
//                       <input {...getInputProps()} />
//                       {isDragActive ? (
//                         <p style={{color: "#13B3C1",paddingTop: "60px"}}>Drop the file here...</p>
//                       ) : (
//                         <p style={{color: "#13B3C1",paddingTop: "60px"}}>Drag & drop a .csv file here, or click to select one</p>
//                       )}
//                     </div>
//                     <div
//                       className="custom-file-container__image-preview mt-3"
//                       style={{ backgroundImage: `url("${dynamicPath}")` }}
//                     ></div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ImportData;
